"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _oneasicsLogoLoading = _interopRequireDefault(require("../../images/oneasics-logo-loading.svg"));

var _stitches = require("../../stitches.config");

var Wrapper = (0, _stitches.styled)('div', {
  alignItems: 'center',
  background: 'rgba(255, 255, 255, 0.9)',
  display: 'flex',
  height: '100vh',
  left: '0',
  position: 'absolute',
  width: '100vw',
  zIndex: '100',
  img: {
    height: '50px',
    width: '100%'
  }
});
/**
 * Loading svg for OneASICS apps.
 */

var Loading = function Loading() {
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement("img", {
    alt: "OneASICS loading logo",
    src: _oneasicsLogoLoading.default
  }));
};

Loading.defaultProps = {};
var _default = Loading;
exports.default = _default;